import { uuid } from 'uuidv4'
import axios from 'axios'
export default {
  namespaced: true,
  state: () => ({
    callId: null,
    chatId: null,
    chat: null,
    user: null,
    muted: false,
    compact: false,
    requestId: null,
    type: 'video',
    status: null,
    expiresAt: null,
    callerId: null,
    videoInited: false
  }),
  getters: {
    callId: state => state.callId,
    status: state => state.status,
    chatId: state => state.chatId,
    chat: state => state.chat,
    user: state => state.user,
    requestId: state => state.requestId,
    type: state => state.type,
    expiresAt: state => state.expiresAt,
    muted: state => state.muted,
    compact: state => state.compact,
    callerId: state => state.callerId,
    videoInited: state => state.videoInited
  },
  mutations: {
    call (state, chatId) {
      state.status = null
      state.chatId = chatId
      state.requestId = uuid()
      state.type = 'video'
    },
    muteToggle (state) {
      state.muted = !state.muted
    },
    screenToggle (state) {
      state.compact = !state.compact
    },
    incoming (state, { callId, caller, chatId, status, expiresAt }) {
      state.requestId = uuid()
      state.type = 'video'
      state.callId = callId
      state.callerId = caller
      state.chatId = chatId
      state.expiresAt = expiresAt
      state.status = status
    },
    setStatus (state, status) {
      state.status = status
    },
    setChatId (state, chatId) {
      state.chatId = chatId
    },
    setCallId (state, id) {
      state.callId = id
    },
    setCallerId (state, id) {
      state.callerId = id
    },
    setExpiration (state, exp) {
      state.expiresAt = exp
    },
    setChat (state, chat) {
      state.chat = chat
    },
    setUser (state, user) {
      state.user = user
    },
    initVideo (state) {
      state.videoInited = true
    },
    answer (state) {},
    finish (state) {},
    decline (state) {},
    reset (state) {
      state.callId = null
      state.chatId = null
      state.chat = null
      state.user = null
      state.requestId = null
      state.type = 'video'
      state.status = null
      state.expiresAt = null
      state.callerId = null
      state.muted = false
      state.videoInited = false
    }
  },
  actions: {
    async initCall ({ state, commit, dispatch }, id) {
      try {
        const response = await axios.get(`/api/chat-spaces/${id}`)
        const chat = response.data.data
        commit('setChat', chat)
        if (chat.type === 'PatientClinic' && this.authType === 'Patient') {
          await dispatch('clinic', chat.chat_space.clinic_id)
        } else {
          if (this.authType === 'Patient') {
            await dispatch('user', chat.chat_space.doctor_id)
          } else {
            await dispatch('user', chat.chat_space.patient_id)
          }
        }
        if (state.callerId) {
          commit('answer', id)
        } else {
          commit('call', id)
        }
      } catch (err) {
        commit('alert/setError', err, { root: true })
      }
    },
    async user ({ commit }, id) {
      try {
        const params = { ids: [id] }
        const response = await axios.post('/api/users', params)
        const user = response.data.data[0]
        commit('setUser', {
          id: user.id,
          name: `${user.firstname.ka} ${user.lastname.ka}`,
          avatar: user.photo
        })
      } catch (err) {
        commit('alert/setError', err, { root: true })
      }
    },
    async clinic ({ commit }, id) {
      try {
        const response = await axios.get(`/api/clinics/${id}`)
        const clinic = response.data.data
        const user = {
          id: clinic.id,
          name: clinic.name.ka,
          avatar: clinic.logo
        }
        commit('setUser', user)
      } catch (err) {
        commit('alert/setError', err, { root: true })
      }
    }
  }
}
